'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("itCompiler", function ($compile, $parse, $interpolate) {
  // perf optim
  function createElement(tagName) {
    return $(document.createElement(tagName));
  }
  return function itCompiler(tableCtrl) {
    var compiler = this;

    // Parent virtuel pour fournir le contrôleur aux directives qui le requièrent (^infiniTable)
    var provider = angular.element('<div>').data('$' + 'infiniTable' + 'Controller', tableCtrl);
    var getConfig = function getConfig() {
      return tableCtrl.getConfig();
    };
    var getContext = function getContext() {
      return tableCtrl.getContext();
    };

    /**
     * Compile all template found in the config object and put them into the linkers.
     * A template is a config attribute matching /(.*)Template$/.
     * Directive can be added to template element if a key matching.
     * For example, for the key rowTemplate, if a key rowDirective is found, the value will be used a directive
     */
    compiler.compileTemplates = function () {
      var config = getConfig();
      var templatePropRegexp = /(.*)Template$/;
      _.each(config, function (value, key) {
        if (templatePropRegexp.test(key)) {
          var templateName = key.substring(0, key.length - "Template".length);
          var template = $(value);
          var directiveKey = templateName + "Directive";
          if (_.has(config, directiveKey)) {
            _.each(config[directiveKey].split(" "), function (directiveName) {
              template.attr(directiveName, "");
            });
          }
          var linkFn = $compile(template);
          tableCtrl.linkers[templateName] = function (scope, cloneConnectFn) {
            return linkFn(scope, function (clone) {
              provider.append(clone); // Attache temporairement au provider pour satisfaire le 'require'
              if (cloneConnectFn) {
                cloneConnectFn(clone);
              }
            });
          };
        }
      });
    };

    /**
     * Compute columns from columns configuration and put computed informations into table context.
     *
     * @param initial true if this is used for initial columns computation
     */
    compiler.computeColumns = function (initial) {
      // TODO : split between compilation and refresh to avoid 'initial' parameter

      var computed = [],
        config = getConfig(),
        context = getContext(),
        groups = [],
        columns = [];
      var columnIdx = 0;
      var addGroup = function addGroup(group) {
        if (group.condition && !group.condition()) {
          return;
        }
        if (!group.id) {
          group.id = group.title ? 'group-' + group.title : 'group-' + groups.length;
        }
        var groupColumns = group.columns;
        var initialIdx = columnIdx;
        var columnCount = 0;
        _.each(groupColumns, function (column) {
          if (addColumn(column)) {
            columnCount++;
          }
        });
        group.fromColumn = initialIdx;
        group.toColumn = initialIdx + columnCount - 1;
        groups.push(group);
      };
      var addColumn = function addColumn(column) {
        if (column.condition && !column.condition()) {
          return false;
        }
        columns.push(column);
        columnIdx++;
        return true;
      };
      _.each(config.columns, function (columnOrGroup, i) {
        var isGroup = columnOrGroup.group || columnOrGroup.columns;
        isGroup ? addGroup(columnOrGroup) : addColumn(columnOrGroup);
      });
      var findGroup = function findGroup(idx) {
        for (var i = 0; i < groups.length; i++) {
          if (idx >= groups[i].fromColumn && idx <= groups[i].toColumn) {
            return groups[i];
          }
        }
        return null;
      };
      var usedIds = [];
      var getId = function getId(column, index) {
        var baseId;
        if (column.id) {
          baseId = column.id;
        } else if (column.attribute) {
          baseId = "col-".concat(column.attribute);
        } else {
          baseId = "col-".concat(index);
        }
        var id = baseId;
        var ext = 0;
        while (usedIds.indexOf(id) > -1) {
          id = "".concat(baseId, "-").concat(ext++);
        }
        usedIds.push(id);
        return id;
      };

      // process columns configuration
      _.each(columns, function (column, i) {
        var columnGroup = findGroup(i);
        computed.push({
          id: getId(column, i),
          index: i,
          column: column,
          group: columnGroup,
          headerInjector: compiler.makeHeaderInjector(column),
          cellInjector: compiler.makeCellInjector(column),
          footerCellInjector: compiler.makeFooterCellContentInjector(column),
          subtotalCellInjector: compiler.makeSubtotalCellContentInjector(column),
          sortable: column.sortable || config.sortable && column.sortable !== false,
          footer: column.footer || false,
          subtotal: column.subtotal || false,
          visible: column.visible != null ? column.visible : true
        });
      });
      context.columns = computed;
      if (initial) {
        _.each(config.columnGroups, function (columnGroup) {
          var visible = _.has(columnGroup, "visible") ? columnGroup.visible : true;
          _.each(columnGroup.columns, function (columnId) {
            var column = _.find(context.columns, {
              id: columnId
            });
            if (column != null) {
              column.visible = visible;
              column.column.visible = visible;
            }
          });
        });
      }
      context.visibleColumns = _.filter(computed, {
        visible: true
      });

      // check if current columns config has displayed group headers.
      var hasHeaderGroups = false;
      for (var i = 0; i < groups.length; i++) {
        var group = groups[i];
        var colspan = 0;
        for (var colIdx = group.fromColumn; colIdx <= group.toColumn; colIdx++) {
          if (computed[colIdx].visible) {
            colspan++;
          }
        }
        if (colspan > 0) {
          hasHeaderGroups = true;
          break;
        }
      }
      context.hasHeaderGroups = hasHeaderGroups;
    };

    /**
     * Compile a cell injector function for given column and returns it.
     *
     * @param column The column configuration object
     *
     * @returns {function} the row injector function, with following parameters :
     *      args[0] : the row element
     *      args[1] : the row scope
     */
    compiler.makeCellInjector = function (column) {
      var config = getConfig(),
        cellTemplate = $(config.cellTemplate);
      if (column.cellClass) {
        cellTemplate.addClass(column.cellClass);
      }
      if (column.linker) {
        // allow usage of custom linker. actually used by the tree renderer's tree column.
        return column.linker;
      } else if (column.template) {
        var cellContentTemplate = _.result(column, "template");
        cellTemplate.html(cellContentTemplate);
        var cellLinkFn = $compile(cellTemplate);
        return function (rowEl, rowScope) {
          cellLinkFn(rowScope, function (cellElement) {
            provider.append(cellElement);
            cellElement.appendTo(rowEl);
          });
        };
      } else if (column.expression) {
        var interpolateFn = $interpolate(column.expression);
        return function (rowEl, rowScope) {
          var cellElement = $(cellTemplate[0].cloneNode(false));
          var cellContent = createElement("span").html(interpolateFn(rowScope));
          cellElement.html(cellContent);
          cellElement.appendTo(rowEl);
        };
      } else {
        var parseFn = $parse("model." + column.attribute + (column.filter ? "|" + column.filter : ""));
        return function (rowEl, rowScope) {
          var cellElement = $(cellTemplate[0].cloneNode(false));
          var cellContent = createElement("span").html(parseFn(rowScope));
          cellElement.html(cellContent);
          cellElement.appendTo(rowEl);
        };
      }
    };
    compiler.makeCellContentInjector = function (column, config) {
      if (column.template) {
        var cellContentTemplate = _.result(column, "template");
        var cellContentTemplateLinkFn = $compile(cellContentTemplate);
        return function (cellScope, cellElement) {
          cellContentTemplateLinkFn(cellScope, function (cellContent) {
            cellContent.appendTo(cellElement);
          });
        };
      } else {
        var expression = column.expression ? column.expression : column.filter ? "{{ model." + column.attribute + " | " + column.filter + " }}" : "{{ model." + column.attribute + " }}";
        if (column.watch || config.watch) {
          // TODO : test can be improved
          var expressionTemplate = "<span>" + expression + "</span>";
          var expressionLinkFn = $compile(expressionTemplate);
          return function (cellScope, cellElement) {
            expressionLinkFn(cellScope, function (expressionElement) {
              expressionElement.appendTo(cellElement);
            });
          };
        } else {
          var interpolateFn = $interpolate(expression);
          return function (cellScope, cellElement) {
            var cellContent = $("<span>").html(interpolateFn(cellScope));
            cellContent.appendTo(cellElement);
          };
        }
      }
    };

    /**
     * Compile a header injector function for given column and returns it.
     *
     * @param column The column configuration objet
     *
     * @returns {function} the header injector function, with following parameters :
     *      args[0] : the row element
     *      args[1] : the row scope
     */
    compiler.makeHeaderInjector = function (column) {
      if (column.headerTemplate) {
        var headerContentTemplate = _.result(column, "headerTemplate");
        var linkFn = $compile(headerContentTemplate);
        return function (headerCell, headerScope) {
          linkFn(headerScope, function (clone) {
            provider.append(clone); // Fournit le contrôleur via le provider
            clone.appendTo(headerCell); // Déplace l'élément vers sa destination finale
          });
        };
      } else {
        return function (headerCell, headerScope) {
          var titles = _.isArray(column.title) ? column.title : [column.title || ""];
          var titleContainer = $("<div>").addClass("it-title-container").appendTo(headerCell);
          _.each(titles, function (title, i) {
            var titleSpan = $("<span>").addClass("it-title").addClass("it-title-" + i).text(title);
            titleContainer.append(titleSpan);
          });
        };
      }
    };

    /**
     * Compile a footer cell injector function for given column and returns it.
     *
     * @param column The column configuration object
     *
     * @returns {function} the footer cell injector function, with following parameters :
     *      args[0] : the row element
     *      args[1] : the row scope
     */
    compiler.makeFooterCellContentInjector = function (column) {
      if (column.footerTemplate) {
        var cellContentTemplate = _.result(column, "footerTemplate");
        var linkFn = $compile(cellContentTemplate);
        return function (cellScope, cellElement) {
          linkFn(cellScope, function (clone) {
            provider.append(clone);
            clone.appendTo(cellElement);
          });
        };
      } else {
        var expression = column.footerExpression ? column.footerExpression : column.footerFilter || column.filter ? "{{ footerValue | " + (column.footerFilter || column.filter) + " }}" : "{{ footerValue }}";
        var expressionTemplate = "<span ng-if=\"footerValue != null\">".concat(expression, "</span>");
        var expressionLinkFn = $compile(expressionTemplate);
        return function (cellScope, cellElement) {
          expressionLinkFn(cellScope, function (expressionElement) {
            expressionElement.appendTo(cellElement);
          });
        };
      }
    };

    /**
     * Compile a subtotal cell injector function for given column and returns it.
     *
     * @param column The column configuration object
     *
     * @returns {function} the subtotal cell injector function, with following parameters :
     *      args[0] : the row element
     *      args[1] : the row scope
     */
    compiler.makeSubtotalCellContentInjector = function (column) {
      if (column.subtotalTemplate) {
        var cellContentTemplate = _.result(column, "subtotalTemplate");
        var linkFn = $compile(cellContentTemplate);
        return function (cellScope, cellElement) {
          linkFn(cellScope, function (clone) {
            provider.append(clone);
            clone.appendTo(cellElement);
          });
        };
      } else {
        var expression = column.subtotalExpression ? column.subtotalExpression : column.subtotalFilter || column.filter ? "{{ subtotalValue | " + (column.subtotalFilter || column.filter) + " }}" : "{{ subtotalValue }}";
        var expressionTemplate = "<span ng-if=\"subtotalValue != null\">".concat(expression, "</span>");
        var expressionLinkFn = $compile(expressionTemplate);
        return function (cellScope, cellElement) {
          expressionLinkFn(cellScope, function (expressionElement) {
            expressionElement.appendTo(cellElement);
          });
        };
      }
    };
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/common/itCompiler.js
// module id = 2793
// module chunks = 13